import styled, { css } from 'styled-components'

export const CartSaveBanner = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 1.2rem;
    box-sizing: border-box;
    flex-shrink: 0;
    width: 100%;
    margin: 0 0 1.2rem;
    padding: 1rem 1.2rem;
    border-radius: ${theme.field?.borderRadius || '0.4rem'};
    border: 1px solid ${theme.colors.error || '#c0392b'};
    background-color: ${theme.colors.errorBackground || '#fdecea'};
  `}
`

export const CartSaveBannerMessage = styled.div`
  flex: 1 1 20rem;
  min-width: 0;
`

export const CartSaveBannerActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  flex-shrink: 0;
`
